module.exports = __webpack_public_path__ + "img/menu_online_codes.f18b6abf.png";